
export default function innerNav() {
  document.addEventListener("DOMContentLoaded", function() {
    const navInview = document.querySelector('.js-innerNavInview');
    const nav = document.querySelector('.js-innerNav');

    const options = { // TODO: 500px is Magic Number
      rootMargin: '-500px 0px 0px 0px',
      threshold: [0,1]
    }

    const inview = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          nav.classList.remove('hide');
        } else {
          nav.classList.add('hide');
        }
      })
    }, options);

    inview.observe(navInview);

  })
}

innerNav();
